import propTypes from 'prop-types';
import { useContext, useState } from 'react';
import {
  CREDIT_REDEEM_DESCRIPTION,
  CREDIT_UNREDEEMS_TITLE,
  GENERIC_FAILURE,
  NO_THANKS,
  YES_PLEASE,
} from '../../../config/text/text';
import { trackEvent } from '../../../helpers/analytics';
import ErrorTrackingService from '../../../helpers/errorTrackingService';
import { usePlaceholderImage } from '../../../helpers/image';
import ThemeContext from '../../../providers/ThemeProvider';
import ToastContext from '../../../providers/ToastProvider';
import { updateVoucher } from '../../../services/vouchers';
import WowModal from '../../WowModal';
import CTAButton from '../../_generic/button/CTAButton';
import Spinner from '../../_generic/spinner/Spinner';

const CreditUnredeemsModal = ({ purchases, mutate }) => {
  const toast = useContext(ToastContext);
  const theme = useContext(ThemeContext);
  const [showModal, setShowModal] = useState(true);
  const [working, setWorking] = useState(false);
  const eligableVouchers = purchases.filter(
    (voucher) => voucher.businessAcceptsCreditUnredeems,
  );

  const accept = async () => {
    setWorking(true);
    trackEvent('credit_auto_refund_click');

    try {
      await Promise.all(
        eligableVouchers.map((voucher) =>
          updateVoucher(voucher.voucherCode, {
            customerHasChosenCreditUnredeems: true,
          }),
        ),
      );
      await mutate();
      setShowModal(false);
    } catch (error) {
      ErrorTrackingService.logError(error);
      toast.addToast(GENERIC_FAILURE);
    }

    setWorking(false);
  };

  if (eligableVouchers.length === 0) {
    return null;
  }

  return (
    <>
      <WowModal
        ariaLabelledBy=""
        centered
        extraClasses="credit-redeems"
        setShowModal={setShowModal}
        showModal={showModal}
        size="md"
      >
        <h4 className="title">{CREDIT_UNREDEEMS_TITLE}*</h4>
        <div className="buttons">
          <CTAButton className="with-margin" onClick={accept}>
            {YES_PLEASE}
          </CTAButton>
          <CTAButton onClick={() => setShowModal(false)} tertiaryButton>
            {NO_THANKS}
          </CTAButton>
        </div>
        <div className="previews">
          {eligableVouchers.map(({ voucherCode, title, image }) => {
            return (
              <div className="preview" key={voucherCode}>
                <img
                  alt={title}
                  className="image"
                  onError={usePlaceholderImage}
                  src={image}
                />
                <p>{title}</p>
              </div>
            );
          })}
        </div>
        <p className="terms">{CREDIT_REDEEM_DESCRIPTION}</p>
        {working && <Spinner display="absolute" />}
      </WowModal>
      <style jsx>{`
        .title {
          color: ${theme.colors.primary};
          font-weight: normal;
          font-size: 1.3em;
          margin: 0;
        }
        .buttons {
          display: flex;
          justify-content: center;
          padding: 30px 0;
        }
        .previews {
          margin-bottom: 30px;
        }
        .preview {
          display: flex;
          margin-bottom: 10px;
        }
        .preview:last-child {
          margin-bottom: 0;
        }
        .image {
          width: 100%;
          border-radius: 5px;
          width: calc(100% / 3 - 20px);
          margin-right: 20px;
        }
        .terms {
          margin: 0;
          font-size: 0.8em;
        }
        :global(.credit-redeems .modal-body) {
          padding: 0 20px 20px 20px;
        }
      `}</style>
    </>
  );
};

CreditUnredeemsModal.propTypes = {
  mutate: propTypes.func,
  purchases: propTypes.arrayOf(propTypes.object),
};

export default CreditUnredeemsModal;
